import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';

const OTPVerifyModal = ({ open, onClose, email, onSendOTP, onCancel, loading = false }) => {
  const [otp, setOtp] = useState('');
  const isSmallMobile = window.innerWidth < 600;

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 5) {
      setOtp(value);
    }
  };

  const handleSend = () => {
    if (otp.length === 5 && onSendOTP) {
      onSendOTP(otp);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1,
          width: isSmallMobile ? '95%' : 'auto',
          m: isSmallMobile ? 1 : 0,
          maxWidth: isSmallMobile ? 'none' : 500
        }
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          py: 2,
          px: isSmallMobile ? 2 : 3,
          position: 'relative'
        }}
      >
        <IconButton
          onClick={onCancel}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.secondary'
          }}
        >
          <CloseIcon />
        </IconButton>

        <LockIcon
          sx={{
            fontSize: isSmallMobile ? 50 : 60,
            color: 'primary.main',
            mb: 2
          }}
        />

        <Typography
          variant="h6"
          sx={{
            fontFamily: 'poppinsSemiBold',
            color: 'text.primary',
            fontSize: isSmallMobile ? '1.1rem' : '1.25rem'
          }}
        >
          Verify OTP
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontFamily: 'poppinsRegular',
            color: 'text.secondary',
            mt: 1,
            fontSize: isSmallMobile ? '0.8rem' : '0.875rem'
          }}
        >
          Enter the OTP sent to your email
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pb: 2, px: isSmallMobile ? 2 : 3 }}>
        {/* Email Field */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 1
            }}
          >
            <EmailIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography
              variant="body2"
              sx={{
                fontFamily: 'poppinsMedium',
                color: 'text.primary'
              }}
            >
              Email Address
            </Typography>
          </Box>

          <TextField
            fullWidth
            value={email}
            InputProps={{
              readOnly: true,
              sx: {
                fontFamily: 'poppinsRegular',
                borderRadius: 1,
                backgroundColor: 'action.hover'
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: 'primary.main'
                }
              }
            }}
          />
        </Box>

        {/* OTP Field */}
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 1
            }}
          >
            <LockIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography
              variant="body2"
              sx={{
                fontFamily: 'poppinsMedium',
                color: 'text.primary'
              }}
            >
              OTP Code
            </Typography>
          </Box>

          <TextField
            fullWidth
            value={otp}
            onChange={handleOtpChange}
            placeholder="ENTER 5-DIGIT OTP"
            type="text"
            inputProps={{
              maxLength: 5,
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: {
                textAlign: 'center',
                fontFamily: 'poppinsMedium'
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: 'primary.main'
                }
              }
            }}
          />

          <Typography
            // variant="caption"
            sx={{
              display: 'block',
              textAlign: 'center',
              mt: 1,
              fontFamily: 'poppinsRegular',
              color: 'text.secondary'
            }}
          >
            Enter the 5-digit code sent to your email
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          pb: 3,
          px: isSmallMobile ? 2 : 3,
          flexDirection: isSmallMobile ? 'column' : 'row'
        }}
      >
        <Button
          onClick={onCancel}
          variant="outlined"
          disabled={loading}
          fullWidth={isSmallMobile}
          sx={{
            minWidth: isSmallMobile ? 'auto' : 100,
            fontFamily: 'poppinsMedium'
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSend}
          variant="contained"
          disabled={loading || otp.length !== 5}
          fullWidth={isSmallMobile}
          sx={{
            minWidth: isSmallMobile ? 'auto' : 100,
            fontFamily: 'poppinsMedium'
          }}
        >
          {loading ? 'Verifying...' : 'Verify OTP'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OTPVerifyModal;
